import { type ColumnDef } from '@tanstack/react-table';
import type { TFunction } from 'i18next';
import { UserAvatar } from '@/shared/components/custom/avatars/UserAvatar';
import type { Client } from '../types';
import { ClientRowActions } from '../components/ClientRowActions';

interface ClientColumnsOptions {
  t: TFunction;
}

export function getClientColumns(options: ClientColumnsOptions): ColumnDef<Client, unknown>[] {
  const { t } = options;

  return [
    {
      accessorKey: 'name',
      header: t('table.name'),
      meta: { cellClassName: 'flex-[2] min-w-0' },
      cell: ({ row }) => {
        const client = row.original;
        return (
          <div className="flex items-center gap-3">
            <UserAvatar name={client.name} color="#3b82f6" size="sm" />
            <span className="font-medium text-foreground">{client.name}</span>
          </div>
        );
      },
    },
    {
      accessorKey: 'taxId',
      header: t('table.taxId'),
      cell: ({ row }) => (
        <span className="text-sm text-muted-foreground">{row.original.taxId}</span>
      ),
    },
    {
      accessorKey: 'primaryContact.name',
      header: t('table.contactName'),
      cell: ({ row }) => {
        const contact = row.original.primaryContact?.name;
        return <span className="text-sm text-foreground">{contact || '-'}</span>;
      },
    },
    {
      id: 'actions',
      header: undefined,
      meta: { cellClassName: 'flex-none w-12 flex justify-end' },
      cell: ({ row }) => <ClientRowActions client={row.original} />,
    },
  ];
}
